import React from 'react'
import { useNavigate } from 'react-router-dom'
import { customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { MainButton, RegularText } from '../../helpers'
import { ModalHeader } from '../../modals'
import HelpIcon from '@mui/icons-material/Help';

import { Box, Button, Grid, Paper, Stack } from '@mui/material'
import { useSelector } from 'react-redux'
import { buildSupportOPT } from '../../../utils/supportOptions'
const iconStyle = {
  fontSize: 40,
  color: customStyles.colors.main
}
export const SupportPage = () => {
  const navigate = useNavigate()
  const { socialNetworks } = useSelector(state => state.info)
  const supportOPT = buildSupportOPT(socialNetworks)
  return (
    <MainContainer>
      <ModalHeader text="¿Necesitas ayuda?" color={customStyles.colors.main} backward action={() => navigate(-1)}/>
      <RegularText text="Si tienes alguna duda o fuga contáctanos, nos encanta ayudarte."/>
      <Grid container spacing={3} mt={3} columnSpacing={3}>
        {/* {
          supportOptions.map(item => (
            item.component
          ))
        } */}
        {
          supportOPT.map(({label, link, icon}) => (
            <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
              {/* <Paper sx={{padding: 3}}> */}

              {icon}
              <RegularText text={label} />
              <Button href={link} target="_blank" variant="outlined" >Ir</Button>
              {/* </Paper> */}
            </Grid>
            // <Button  key={label} href={link} target="_blank" startIcon={icon}>{label}</Button>
          ))
        }
        {/* <Button startIcon={<HelpIcon />} onClick={() => navigate('/dashboard/preguntas-frecuentes')}>Preguntas frecuentes</Button> */}
        <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
          {/* <Paper sx={{padding: 3}}> */}

          <HelpIcon sx={iconStyle}/>
          <RegularText text="Preguntas frecuentes" />
          <Button onClick={() => navigate('/dashboard/preguntas-frecuentes')} variant="outlined">Ir</Button>
          {/* </Paper> */}
        </Grid>
      </Grid>
    </MainContainer>
  )
}
